export const createRequestObject = (context) => {
  const request = {
    url: context.request?.url || context.url || "",
    method: context.request?.method || context.method || "GET",
    headers: context.request?.headers || context.headers || {},
    body: context.request?.body || context.body || "",
    queryParams: context.request?.queryParams || context.queryParams || {},

    url: {
      toString: () => context.request?.url || context.url || "",
      addQueryParams: (params) => {
        const urlStr = context.request?.url || context.url || "http://localhost";
        try {
          const url = new URL(urlStr);
          Object.entries(params).forEach(([key, value]) => {
            url.searchParams.set(key, value);
          });
          const newUrl = url.toString();
          context.request.url = newUrl;
          return newUrl;
        } catch (e) {
          return urlStr;
        }
      },
      removeQueryParams: (paramNames) => {
        const urlStr = context.request?.url || context.url || "http://localhost";
        try {
          const url = new URL(urlStr);
          paramNames.forEach((param) => {
            url.searchParams.delete(param);
          });
          const newUrl = url.toString();
          context.request.url = newUrl;
          return newUrl;
        } catch (e) {
          return urlStr;
        }
      },
      addPathParams: (params) => {
        let url = context.request?.url || context.url || "";
        Object.entries(params).forEach(([key, value]) => {
          url = url.replace(`{${key}}`, value);
        });
        context.request.url = url;
        return url;
      },
    },

    headers: {
      add: (header) => {
        if (typeof header === "object" && header.key && header.value) {
          if (typeof context.request.headers === "string") {
            try {
              context.request.headers = JSON.parse(context.request.headers);
            } catch {
              context.request.headers = {};
            }
          }
          if (typeof context.request.headers !== "object") context.request.headers = {};
          context.request.headers[header.key] = header.value;
        }
      },
      remove: (headerName) => {
        if (typeof context.request.headers === "string") {
          try {
            context.request.headers = JSON.parse(context.request.headers);
          } catch {
            context.request.headers = {};
          }
        }
        if (typeof context.request.headers === "object") delete context.request.headers[headerName];
      },
      replace: (header) => {
        if (typeof header === "object" && header.key && header.value) {
          if (typeof context.request.headers === "string") {
            try {
              context.request.headers = JSON.parse(context.request.headers);
            } catch {
              context.request.headers = {};
            }
          }
          if (typeof context.request.headers !== "object") context.request.headers = {};
          context.request.headers[header.key] = header.value;
        }
      },
      get: (headerName) => {
        let headers = context.request.headers;
        if (typeof headers === "string") {
          try {
            headers = JSON.parse(headers);
          } catch {
            headers = {};
          }
        }
        if (typeof headers !== "object") headers = {};
        return headers[headerName.toLowerCase()] || headers[headerName];
      },
      has: (headerName) => {
        let headers = context.request.headers;
        if (typeof headers === "string") {
          try {
            headers = JSON.parse(headers);
          } catch {
            headers = {};
          }
        }
        if (typeof headers !== "object") headers = {};
        return headerName.toLowerCase() in headers || headerName in headers;
      },
      all: () => {
        let headers = context.request.headers;
        if (typeof headers === "string") {
          try {
            headers = JSON.parse(headers);
          } catch {
            headers = {};
          }
        }
        if (typeof headers !== "object") headers = {};
        return headers;
      },
    },

    queryParams: {
      add: (key, value) => {
        if (typeof context.request.queryParams === "string") {
          try {
            context.request.queryParams = JSON.parse(context.request.queryParams);
          } catch {
            context.request.queryParams = {};
          }
        }
        if (typeof context.request.queryParams !== "object") context.request.queryParams = {};
        context.request.queryParams[key] = value;
      },
      remove: (key) => {
        if (typeof context.request.queryParams === "string") {
          try {
            context.request.queryParams = JSON.parse(context.request.queryParams);
          } catch {
            context.request.queryParams = {};
          }
        }
        if (typeof context.request.queryParams === "object")
          delete context.request.queryParams[key];
      },
      get: (key) => {
        let queryParams = context.request.queryParams;
        if (typeof queryParams === "string") {
          try {
            queryParams = JSON.parse(queryParams);
          } catch {
            queryParams = {};
          }
        }
        if (typeof queryParams !== "object") queryParams = {};
        return queryParams[key];
      },
      has: (key) => {
        let queryParams = context.request.queryParams;
        if (typeof queryParams === "string") {
          try {
            queryParams = JSON.parse(queryParams);
          } catch {
            queryParams = {};
          }
        }
        if (typeof queryParams !== "object") queryParams = {};
        return key in queryParams;
      },
      all: () => {
        let queryParams = context.request.queryParams;
        if (typeof queryParams === "string") {
          try {
            queryParams = JSON.parse(queryParams);
          } catch {
            queryParams = {};
          }
        }
        if (typeof queryParams !== "object") queryParams = {};
        return queryParams;
      },
    },

    body: {
      get raw() {
        return context.request?.body || context.body || "";
      },
      set raw(value) {
        context.request.body = value;
      },
      formdata: {
        add: (field) => {
          if (typeof field === "object" && field.key && field.value) {
            let body = context.request.body;
            if (typeof body === "string") {
              try {
                body = JSON.parse(body);
              } catch {
                body = {};
              }
            }
            if (typeof body !== "object") body = {};
            body[field.key] = field.value;
            context.request.body = body;
          }
        },
        remove: (fieldName) => {
          let body = context.request.body;
          if (typeof body === "string") {
            try {
              body = JSON.parse(body);
            } catch {
              body = {};
            }
          }
          if (typeof body === "object") {
            delete body[fieldName];
            context.request.body = body;
          }
        },
      },
      urlencoded: {
        add: (field) => {
          if (typeof field === "object" && field.key && field.value) {
            let body = context.request.body;
            if (typeof body === "string") {
              try {
                body = JSON.parse(body);
              } catch {
                body = {};
              }
            }
            if (typeof body !== "object") body = {};
            body[field.key] = field.value;
            context.request.body = body;
          }
        },
        remove: (fieldName) => {
          let body = context.request.body;
          if (typeof body === "string") {
            try {
              body = JSON.parse(body);
            } catch {
              body = {};
            }
          }
          if (typeof body === "object") {
            delete body[fieldName];
            context.request.body = body;
          }
        },
      },
    },

    auth: {
      basic: (authData) => {
        if (authData.username && authData.password) {
          const credentials = btoa(`${authData.username}:${authData.password}`);
          if (typeof context.request.headers === "string") {
            try {
              context.request.headers = JSON.parse(context.request.headers);
            } catch {
              context.request.headers = {};
            }
          }
          if (typeof context.request.headers !== "object") context.request.headers = {};
          context.request.headers["Authorization"] = `Basic ${credentials}`;
        }
      },
      bearer: (token) => {
        if (typeof context.request.headers === "string") {
          try {
            context.request.headers = JSON.parse(context.request.headers);
          } catch {
            context.request.headers = {};
          }
        }
        if (typeof context.request.headers !== "object") context.request.headers = {};
        context.request.headers["Authorization"] = `Bearer ${token}`;
      },
      digest: () => {},
      oauth1: () => {},
      oauth2: () => {},
      awsv4: () => {},
      hawk: () => {},
      ntlm: () => {},
    },
  };

  return request;
};
